import axiosInstance from 'axiosInstance';

export const fetchDevTestingSummary = async () => {
  const response = await axiosInstance.get('modules/dev-testing/summary');
  return response.data;
};

export const createMlTestUser = async () => {
  const response = await axiosInstance.post('modules/dev-testing/test-users');
  return response.data;
};

export const deleteMlTestUser = async testUserId => {
  const response = await axiosInstance.delete(`modules/dev-testing/test-users/${testUserId}`);
  return response.data;
};
